import type { Order } from '@shopgnd/shared';

/** Roles that may view any order (platform operations). */
export function isPlatformOrderAdmin(roles: string[] | undefined): boolean {
  return roles?.includes('admin') === true || roles?.includes('platform_admin') === true;
}

export function canViewOrderAsBuyer(
  roles: string[] | undefined,
  userId: string | undefined,
  order: Order,
): boolean {
  if (!userId) return false;
  if (isPlatformOrderAdmin(roles)) return true;
  return order.buyerUserId === userId;
}

export function canViewOrderAsVendorOwner(
  vendorId: string | null | undefined,
  order: Order,
): boolean {
  return Boolean(vendorId && order.vendorId === vendorId);
}
